import React from 'react';
import { motion } from 'framer-motion';
import { GlassPanel } from '../components/common/GlassPanel';

const EducationImpl = ({ accent, mood }) => (
  <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen pt-32 pb-48 px-4 sm:px-4 sm:px-8 lg:px-24">
    <h2 className="text-5xl font-black italic text-white mb-16 uppercase tracking-tighter">EDUCATION</h2>

    <GlassPanel mood={mood} className="p-10 rounded-3xl max-w-2xl">
      <h3 className="text-2xl font-black text-white mb-2">
        Bachelor’s Degree
      </h3>
      <p className="mb-4 font-black uppercase text-xs tracking-widest" style={{ color: accent.color }}>Computer Science</p>
      <p className="text-white/60 leading-relaxed">
        Currently pursuing undergraduate studies while building full-stack projects.
      </p>
    </GlassPanel>
  </motion.div>
);

export const Education = React.memo(EducationImpl);
